import React from "react";

export default function PrivacyScreen() {
  return (
    <main style={{ maxWidth: 900, margin: "0 auto", padding: 20 }}>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> {new Date().toLocaleDateString()}</p>

      <h2>1) What we collect</h2>
      <ul>
        <li>Account info (e.g., email, display name)</li>
        <li>Profile info you provide (photos, bio, city, preferences)</li>
        <li>Messages and interactions (to provide chat and safety features)</li>
        <li>Device and log data (basic analytics, security, fraud prevention)</li>
      </ul>

      <h2>2) How we use information</h2>
      <ul>
        <li>To provide matching, messaging, and account features</li>
        <li>To enforce safety rules and prevent abuse/scams</li>
        <li>To improve performance and user experience</li>
        <li>To comply with legal obligations</li>
      </ul>

      <h2>3) Sharing</h2>
      <p>
        We don’t sell your personal data. We may share limited info with service providers
        (hosting, analytics, security) only to operate the platform, and when required by law.
      </p>

      <h2>4) Safety & moderation</h2>
      <p>
        We may review reports and take action (warnings, content removal, bans) to protect the
        community.
      </p>

      <h2>5) Your choices</h2>
      <ul>
        <li>You can edit your profile at any time.</li>
        <li>You can block and report other users.</li>
        <li>You can request account deletion (if you provide a deletion method/support channel).</li>
      </ul>

      <h2>6) Data retention</h2>
      <p>
        We keep data only as long as needed for the service, safety, and legal compliance. Some
        records may be retained for fraud prevention and dispute resolution.
      </p>

      <h2>7) Adults only</h2>
      <p>
        GhanaDating is for adults (18+) only. We do not knowingly collect data from users under 18.
      </p>

      <h2>8) Updates</h2>
      <p>
        We may update this policy. Continued use means you accept the updated version.
      </p>
    </main>
  );
}